import { Flex, Logo } from 'core/components';
import { boxPadding } from 'core/modifiers';

import PageOrganizationsCreate from 'hcp/components/page/organizations/create';

<template>
  {{!
    Warning: This full-screen layout is only applied when no organizations exist
    on this page. The other moving part of this condition is inside the component
    wrapper for hcp-app-frame. The sidebar navigation will be hidden if no orgs
    exist on *every* route. We might want to consider this full-screen layout at
    the cloud route template instead.
  }}

  {{#if @controller.model.organizations.length}}
    <PageOrganizationsCreate
      @onSuccess={{@controller.model.onSuccess}}
      @organizations={{@controller.model.organizations}}
      @userId={{@controller.model.userId}}
    />
  {{else}}
    <Flex @direction="column" {{boxPadding "lg"}}>
      <header>
        <Logo />
      </header>
      <div class="organizations-create">
        <PageOrganizationsCreate
          @onSuccess={{@controller.model.onSuccess}}
          @organizations={{@controller.model.organizations}}
          @userId={{@controller.model.userId}}
        />
      </div>
    </Flex>
  {{/if}}
</template>
